import bRadio from './b-radio'

bRadio.install = function (Vue) {
  Vue.component(bRadio.name, bRadio)
}

export default bRadio
